import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import PageTop from '../components/pageTop/PageTop';
import Footer from '../components/footer/Footer';

function NewsDetail() {
  const navigate = useNavigate();

  return (
    <Container>
      <PageTop text="경공매 뉴스" />
      <Content>
        <NewsContent>
          <TitleSection>
            <Title>
              대구 역세권 공장땅 1100평, 반값 경매…최저가 39억에 8일 입찰
              <img
                src="/assets/images/icon/new.svg"
                alt="NEW"
                width={16}
                height={16}
              />
            </Title>
            <Date>2025.04.03</Date>
          </TitleSection>
          <Divider />
          <ContentSection>
            [땅집고] 대구시 각산동에서 지하철역을 낀 1100여평 규모 공장부지가
            감정가 반값에 경매로 나왔다. 낙찰받은 후 공장으로 써도 되지만 인근에
            아파트가 밀집한 점을 고려하면 도심형 제조시설이나 연구개발(R&D) 센터
            등 다양한 용도로 활용 가능하다. 주변 공장부지 시세와 비교하면 절반
            수준에 낙찰이 가능해 가격 경쟁력이 있다는 평가다.
          </ContentSection>
          <SimpleNavigation>
            <NavigationItem>
              <NavigationType>이전기사</NavigationType>
              <NavigationTitle>
                대구 역세권 공장땅 1100평, 반값 경매…최저가 39억에 8일 입찰
              </NavigationTitle>
            </NavigationItem>
            <NavigationItem>
              <NavigationType>다음기사</NavigationType>
              <NavigationTitle>
                전주 인후동 15평 아파트 낙찰, 8개월만에 2000만원 순수익
              </NavigationTitle>
            </NavigationItem>
          </SimpleNavigation>
        </NewsContent>
        <ListButton onClick={() => navigate('/news')}>목록으로</ListButton>
      </Content>
      <Footer />
    </Container>
  );
}

export default NewsDetail;

const Container = styled.div`
  width: 100%;
  position: relative;
`;

const Content = styled.div`
  display: flex;
  padding: 40px 16px 72px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 64px;
`;

const NewsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

const Date = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
  color: rgba(55, 56, 60, 0.61);
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e1e2e4;
`;

const ContentSection = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
  min-height: 500px;
`;

const SimpleNavigation = styled.div`
  display: flex;
  padding: 8px 0px;
  flex-direction: column;
  align-items: flex-start;
  border-top: 1px solid #e1e2e4;
  border-bottom: 1px solid #e1e2e4;
`;

const NavigationItem = styled.div`
  display: flex;
  padding: 8px 0px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  cursor: pointer;
`;

const NavigationType = styled.div`
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
  color: #616161;
  white-space: nowrap;
`;

const NavigationTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const ListButton = styled.button`
  width: fit-content;
  padding: 14px 48px;
  border-radius: 8px;
  background: #222;
  cursor: pointer;

  color: #fff;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;
